<div class="bankid-status">
  @switch (signeringStatus()) {
    @case (BankIdSigneringStatus.ordre_mottatt) {
      <ng-container *ngTemplateOutlet="venterPaaSignering"></ng-container>
    }
    @case (BankIdSigneringStatus.bruker_signerer) {
      <ng-container *ngTemplateOutlet="venterPaaSignering"></ng-container>
    }
    @case (BankIdSigneringStatus.avvist) {
      <div class="statusblokk">
        <div class="statusoverskrift">{{ 'Manglende samtykke til behandling av personopplysninger' | translate }}</div>
        <p>{{ 'Start signering på nytt og gi samtykke til å behandle dine personopplysninger for å fullføre signering.' | translate }}</p>
      </div>
    }
    @case (BankIdSigneringStatus.feilet) {
      <div class="statusblokk">
        <div class="statusoverskrift">{{ 'Feil' | translate }}</div>
        <p>{{ 'Det oppsto en feil under signeringen. Start signering på nytt.' | translate }}</p>
      </div>
    }
    @case (BankIdSigneringStatus.utlopt) {
      <div class="statusblokk">
        <div class="statusoverskrift">{{ 'Tidsavbrudd' | translate }}</div>
        <p>{{ 'Signeringen utløp på tid. Du må fullføre signeringen innen 5 minutter etter at den er påbegynt. ' | translate }}</p>
      </div>
    }
    @case (BankidKlientFeil.PopupBlokkert) {
      <div class="statusblokk">
        <div class="statusoverskrift">{{ 'Nytt vindu blokkert' | translate }}</div>
        <p>{{ 'Vi kunne ikke åpne et nytt vindu for å fortsette til signering. Sjekk om nettleseren din blokkerer nye vinduer/popups fra Styreplan.' | translate }}</p>
      </div>
    }
    @case (BankIdSigneringStatus.signering_fullfort) {
      <div class="statusblokk" data-testid="bankid-signering-gjennomfort">
        <div class="statusoverskrift" translate>Signering med BankID gjennomført.</div>
        <div>{{'Dokumentet {dokument} er signert.' | translate: {dokument: dokumentnavn()} }}</div>
      </div>
    }

    @default {
      <div class="statusblokk">
        <div class="statusoverskrift">{{ 'Signer med BankID' | translate }}</div>
        <p>{{ 'Signering med BankID åpner et nytt vindu for signering.' | translate }}</p>
        <p>{{ 'Klikk på "Signer" og følg stegene i signeringsvinduet for å signere {filnavn} .' | translate: {filnavn: dokumentnavn()} }}</p>
      </div>
    }
  }
</div>

<ng-template #venterPaaSignering>
  <div class="statusblokk">
    <div>
      <mat-progress-bar mode="indeterminate" diameter="50"/>
      <div class="statusoverskrift">{{ 'Venter på signering...' | translate }}</div>
    </div>
    <div>
      <p>{{ 'Følg stegene i signeringsvinduet som åpnet seg for å signere {filnavn} .' | translate: {filnavn: dokumentnavn()} }}</p>
      <p translate>Dette vinduet lukkes av seg selv når signeringen er fullført hos BankID.</p>
    </div>
    <div>
      <tips>
        <p translate>Fikk du ikke nytt vindu? Sjekk om adressefeltet i nettleseren viser melding om blokkert popup-vindu.</p>
        <p translate>Har du lukket signeringsvinduet? Lukk dette vinduet og start signering på nytt.</p>
      </tips>
    </div>
  </div>
</ng-template>
